module.exports = __webpack_public_path__ + "img/专利证书11_能效在线评估系统后台配置软件v1.0.81eb6f65.png";